import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const MobileOfflineIndicator = ({ isOnline, lastCachedUpdate }) => {
  const [showIndicator, setShowIndicator] = useState(!isOnline);

  useEffect(() => {
    setShowIndicator(!isOnline);
  }, [isOnline]);

  if (!showIndicator) return null;

  return (
    <div className="fixed top-20 left-4 right-4 z-40 bg-warning text-warning-foreground rounded-lg shadow-lg p-3 animate-slide-down">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 mt-0.5">
          <Icon name="WifiOff" size={20} color="var(--color-warning-foreground)" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold mb-1">Offline Mode</p>
          <p className="text-xs opacity-90">
            Showing cached data from {lastCachedUpdate}
          </p>
        </div>
        <button
          onClick={() => setShowIndicator(false)}
          className="flex-shrink-0 opacity-80 hover:opacity-100 transition-opacity"
          aria-label="Dismiss offline indicator"
        >
          <Icon name="X" size={16} color="var(--color-warning-foreground)" />
        </button>
      </div>
    </div>
  );
};

export default MobileOfflineIndicator;